"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SvgAngleRightIcon = (0, react_1.forwardRef)((props, ref) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 15 25', ref: ref }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: 'currentColor', fillRule: 'nonzero', d: 'M14.372 11.03a2.045 2.045 0 0 1 0 2.947L3.66 24.39a2.19 2.19 0 0 1-3.032 0 2.045 2.045 0 0 1 0-2.948L9.826 12.5.634 3.558a2.045 2.045 0 0 1 0-2.948 2.19 2.19 0 0 1 3.033 0L14.38 11.023z' }) })));
});
exports.default = (0, react_1.memo)(SvgAngleRightIcon);
